import BillRecordEntry from "@/pages/billPages/layout/BillRecordEntry";
export default [
  {
    path: '/bill-record',
    component: BillRecordEntry,
    name: "BillRecordEntry",
    children: [
      {
        path: '/bill-billList',
        name: 'BillBillList',
        component: () => import("@/pages/billPages/BillList"),
      },
      {
        path: '/bill-outbillrecord',
        name: 'OutBillRecord',
        component: () => import("@/pages/billPages/OutBillRecord"),
      },
      {
        path: '/bill-outbilldetail',
        name: 'OutBillDetail',
        component: () => import("@/pages/billPages/OutBillDetail"),
      },
      {
        path: '/bill-electronic-invoice-preview',
        name: 'ElectronicInvoicePreview',
        component: () => import("@/pages/billPages/ElectronicInvoicePreview"),
      },
      {
        path: '/bill-hosin-billlist',
        name: 'HosInBillList',
        component: () => import("@/pages/billPages/HosInBillList"),
      },
      {
        path: '/bill-hosin-billinfo',
        name: 'HosInBillInfo',
        component: () => import("@/pages/billPages/HosInBillInfo"),
      },
      {
        path: '/bill-hosin-billdetail',
        name: 'HosInBillDetail',
        component: () => import("@/pages/billPages/HosInBillDetail"),
      },
      {
        path: '/bill-visitList',
        name: 'BillVisitList',
        component: () => import("@/pages/billPages/VisitList"),
      },
      {
        path: '/bill-SeachList',
        name: 'BillSeachList',
        component: () => import("@/pages/billPages/SeachList"),
      },
    ]
  },
  {
    path: '/bill-sharpdf',
    name: 'BillSharePDF',
    component: () => import("@/pages/billPages/SharePDF"),
  },


]



// WEBPACK FOOTER //
// ./src/router/modules/billRoutes.js